__turbopack_context__.v({
  "coinsInWallet": "WalletDescription-module__40b_yG__coinsInWallet",
  "root": "WalletDescription-module__40b_yG__root",
  "tickerIcon": "WalletDescription-module__40b_yG__tickerIcon",
  "viewAll": "WalletDescription-module__40b_yG__viewAll",
  "walletDetailContainer": "WalletDescription-module__40b_yG__walletDetailContainer",
  "walletDetailRow": "WalletDescription-module__40b_yG__walletDetailRow",
});
